module.exports = __webpack_public_path__ + "img/bgc.3b2fb062.png";